import * as React from 'react'
import * as T from 'components/ui/typography'

import Button from 'components/shared/button'

import router from 'next/router'
import Routes from 'utils/routes'
import NoCreditDialog from 'components/shared/credit-dialog'
import UseCreditsCheck from 'hooks/credits/use-credits-check'
import GradientBox from 'components/shared/gradient-box'

interface PropsOptionLabel {
    title: string
    description: string
    icon?: JSX.Element
    btnTxt?: string
    mode?: 'ANCHOR' | 'REGULAR'
    subjectId?: string
    type?: 'QUIZ' | 'SIM'
    banner?: boolean
}

const CardCreateQuiz: React.FC<PropsOptionLabel> = (props: PropsOptionLabel) => {
    const { simCreditsCheck, quizCreditsCheck } = UseCreditsCheck()

    const handleCreateSim = () => {
        router.push({ pathname: Routes.NewSimulation, query: { mode: 'GENERATE' } })
    }
    const handleCreateQuiz = () => {
        router.push({ pathname: Routes.NewQuiz, query: { mode: props.mode, subject: props.subjectId } })
    }

    const adaptToBannerFlexDir = React.useMemo(() => (props.banner ? 'flex-col' : 'flex-row'), [props.banner])
    const adaptToBannerMargin = React.useMemo(() => (props.banner ? 'mt-2' : 'mt-0'), [props.banner])
    const adaptToBannerBtnWidth = React.useMemo(() => (props.banner ? 'w-full' : 'w-4/10'), [props.banner])

    return (
        <GradientBox
            className={`flex gap-6 rounded-lg flex-col lg:${adaptToBannerFlexDir} justify-between items-center p-6`}>
            <div className="flex flex-col items-start justify-between flex-1 ">
                <div className="flex flex-1 w-full items-center">
                    {props.icon ? <div className="flex m-2 pb-1.5 ml-0">{props.icon}</div> : null}
                    <T.H2 className="text-secondary my-1">{props.title}</T.H2>
                </div>
                <T.Small className="text-secondary  w-full sm:w-8/10">{props.description}</T.Small>
            </div>
            <div
                className={`flex self-start md:self-end mt-2 md:${adaptToBannerMargin} w-full sm:${adaptToBannerBtnWidth} justify-center md:justify-end gap-4 flex-1 sm:flex-[0.3_0.3_0%]`}>
                {!simCreditsCheck() || !quizCreditsCheck() ? (
                    <NoCreditDialog
                        trigger={
                            <Button data-testid="start-test" className={'px-3 uppercase w-full md:w-[160px]'}>
                                {props.btnTxt || ''}
                            </Button>
                        }
                    />
                ) : (
                    <Button
                        data-testid="start-test"
                        onClick={props.type === 'QUIZ' ? () => handleCreateQuiz() : () => handleCreateSim()}
                        className={'px-3 uppercase w-full md:w-[160px]'}>
                        {props.btnTxt || ''}
                    </Button>
                )}
            </div>
        </GradientBox>
    )
}

export default CardCreateQuiz
